/**
 * EveningPlate: the painted plate at the head of an evening, with its title
 * beneath it the way a plate is captioned in a book. Renders nothing until that
 * evening's plate exists (data/artwork.js lists them).
 *
 * It sits above the scene and never inside it: once the evening starts, the
 * reader's own picture of the courtyard is the one that counts.
 */
import React from 'react';
import { clsx } from 'clsx';
import ArtImage from './ArtImage';
import { getArt } from './artFiles';
import { PLATES } from '../../data/artwork';

const EveningPlate = ({ evening, className }) => {
  const plate = PLATES[evening];
  if (!plate || !getArt(plate.file)) return null;

  return (
    <figure
      className={clsx(
        'rounded-2xl overflow-hidden border border-courtyard-gold/40 bg-courtyard-stone-dark shadow-courtyard-md',
        className
      )}
    >
      <ArtImage
        stem={plate.file}
        alt={plate.alt}
        width={1600}
        height={900}
        sizes="(min-width: 768px) 736px, 100vw"
        eager
        className="block w-full h-auto"
      />
      <figcaption className="px-4 py-2 text-sm italic text-courtyard-parchment">
        {plate.title}
      </figcaption>
    </figure>
  );
};

export default EveningPlate;
